<template>
  <card>
    <slot name="header">
      <h2 class="card-title card-header" v-if="bibleStudy">
        {{ bibleStudy.name }}
        <!-- <i
          class="el-icon-edit icon-btn"
          style="font-size: .4em;"
          @click="openEditBSModal()"
          v-if="bibleStudy"
          v-show="bibleStudy.status == 'Active'
            && (bibleStudy.user_is_leader ||
              isOneOfTheseRoles(['td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni']))"
        /> -->
      </h2>
      <div
        class="medium card-header"
        v-if="bibleStudy
          && !isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])"
      >
        {{ bibleStudy.reporting_percentage }}% reported,
        <span
          :class="{
            'error-text': bibleStudy.reports_missing > 0
          }"
          v-if="bibleStudy"
        >{{ bibleStudy.reports_missing }} missing</span>
      </div>
    </slot>

    <table class="table table-bordered">
      <tbody>
        <tr>
          <td>Leader(s)</td>
          <td v-if="bibleStudy">
            <span
              class="clickable-paragraph"
              v-for="(leader, index) in bibleStudy.leaders"
              :key="leader.id"
              @click="goToPersonProfile(leader.person_id)"
            >
              {{ leader.name }}<span v-if="index < bibleStudy.leaders.length - 1">,&nbsp;</span>
            </span>
          </td>
        </tr>
        <tr>
          <td>Start Date</td>
          <td v-if="bibleStudy">
            {{ bibleStudy.start_date }}
          </td>
        </tr>
        <tr v-if="bibleStudy.end_date">
          <td>End Date</td>
          <td>
            {{ bibleStudy.end_date }}
          </td>
        </tr>
        <tr>
          <td>Meets</td>
          <td v-if="bibleStudy && !isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])">
            {{ bibleStudy.meeting_time }}, {{ bibleStudy.meeting_location }}
          </td>
          <td v-if="isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])">
            {{ bibleStudy.meeting_time }}, {{ bibleStudy.recurring_type }}, {{ bibleStudy.meeting_location }}
            <!-- <el-button
              class="small"
              v-if="bibleStudy"
              v-show="bibleStudy.status == 'Active'
                && bibleStudy.user_is_leader"
              @click="handleCreateBSA()"
              style="float: right; color: black;"
            >
              <i class="el-icon-edit-outline" />
            </el-button> -->
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td v-if="bibleStudy">
            {{ bibleStudy.status }}
            <!-- <el-button
              class="small"
              v-if="bibleStudy"
              v-show="bibleStudy.status == 'Active'
                && (bibleStudy.user_is_leader || isOneOfTheseRoles(['td', 'missionary', 'affiliate']))"
              @click="openMarkBSCompletedModal()"
              style="float: right; color: black;"
            >
              <i class="el-icon-success" />
            </el-button> -->
          </td>
        </tr>
      </tbody>
    </table>

    <slot name="footer" class="card-footer">
      <p v-show="bibleStudy.is_on_vacation">
        Attendances are not currently being generated for your bible study because your campus is on vacation.
        To create an attendance for a specific date, click "Add attendance" below.
      </p>
      <i
        class="el-icon-edit icon-btn"
        @click="openEditBSModal()"
        v-if="bibleStudy"
        v-show="bibleStudy.status == 'Active' &&
          (
            bibleStudy.user_is_leader ||
            isOneOfTheseRoles(['td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary'])
          )
        "
      />
      <el-button
        v-if="bibleStudy"
        v-show="bibleStudy.status == 'Active'
          && (
            bibleStudy.user_is_leader ||
            isOneOfTheseRoles(['td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary'])
          )
        "
        @click="openMarkBSCompletedModal()"
        style="position: relative; float: right; margin-right: 10px;"
      >
        <i class="el-icon-success" /> End this study
      </el-button>
      <el-button
        v-if="bibleStudy"
        v-show="bibleStudy.status == 'Active'
          && (bibleStudy.user_is_leader &&
            (
              isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])
              || bibleStudy.is_on_vacation
            ))"
        @click="handleCreateBSA()"
        style="position: relative; float: right; margin-right: 10px;"
      >
        <i class="el-icon-edit-outline" /> Add attendance
      </el-button>
      <el-button
        v-if="bibleStudy"
        v-show="isOneOfTheseRoles(['superadmin']) && bibleStudy.status == 'Active' && bibleStudy.end_date"
        @click="openReopenBSModal()"
        style="position: relative; float: right; margin-right: 10px;"
      >
        Remove End Date
      </el-button>
      <el-button
        v-if="bibleStudy"
        v-show="isOneOfTheseRoles(['superadmin']) && bibleStudy.status == 'Completed'"
        @click="openReopenBSModal()"
        style="position: relative; float: right; margin-right: 10px;"
      >
        Re-open Study
      </el-button>
    </slot>

    <CBSM
      :show="modals.completeBSOpen"
      :bible-study="bibleStudy"
      @close="modals.completeBSOpen = false"
      @save="recallBibleStudy()"
    />

    <BSEM
      :show="modals.editBSOpen"
      :bible-study="bibleStudy"
      @close="modals.editBSOpen = !modals.editBSOpen"
    />

    <CAM
      :show="modals.createBSAopen"
      :bible-study="bibleStudy"
      @close="modals.createBSAopen = !modals.createBSAopen"
      @submitted="recallBibleStudy()"
    />

    <RBSM
      :show="modals.reopenBSModalopen"
      :bible-study="bibleStudy"
      @close="modals.reopenBSModalopen = !modals.reopenBSModalopen"
    />
  </card>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import card from '../UIComponents/Cards/Card';
import CompleteBSModal from './CompleteModal';
import BibleStudyEditModal from './EditModal';
import CreateAttendanceModal from './Attendance/CreateModal';
import ReopenBibleStudyModal from './ConfirmReopenModal.vue';

export default {
    components: {
        card,
        CBSM: CompleteBSModal,
        BSEM: BibleStudyEditModal,
        CAM: CreateAttendanceModal,
        RBSM: ReopenBibleStudyModal
    },
    data() {
        return {
            namespace: 'BibleStudies',
            modals: {
                completeBSOpen: false,
                editBSOpen: false,
                createBSAopen: false,
                reopenBSModalopen: false
            },
        };
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        openEditBSModal() {
            // Fetch eligible leaders into state for edit BS modal
            this.$store.dispatch(`${this.namespace}/getEligibleLeaders`).then(
                this.modals.editBSOpen = !this.modals.editBSOpen
            );
        },
        openMarkBSCompletedModal() {
            this.modals.completeBSOpen = !this.modals.completeBSOpen;
        },
        handleCreateBSA() {
            this.$store.dispatch(`${this.namespace}/createBibleStudyAttendance`,
                { bibleStudyId: this.$route.params.id }).then(
                this.modals.createBSAopen = !this.modals.createBSAopen
            );
        },
        recallBibleStudy() {
            this.$emit('recallBibleStudy');
            this.modals.editBSOpen = !this.modals.editBSOpen;
        },
        goToPersonProfile(id) {
            this.$router.push({ name: 'PersonShow', params: { id } });
        },
        goBack() {
            return this.$router.go(-1);
        },
        openReopenBSModal() {
            this.modals.reopenBSModalopen = !this.modals.reopenBSModalopen;
        }
    },
    props: {
        bibleStudy: Object,
    }
};
</script>
<style>
.card-header{
  text-align: center;
  margin: 20px 0;
}
.card-footer {
  display: flex;
  justify-content: space-between;
}
.medium{
  font-size: 125%;
}
</style>
